import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import CompareModal from "./CompareModal";
import GraphicCard from "components/GraphicCard";
import Picture from "components/Picture";
import styled from "styled-components";
import { getAudienceEmoji } from "posts/constants";

const StyledPicture = styled(Picture)`
  img {
    width: 100%;
  }
`;

function AudienceMapCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderImage = (src, alt) => {
    return <Picture image={src} imageAlt={alt} />;
  };

  const renderAudienceImage = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return renderImage(
          "/images/county_map_tc.png",
          "This is an image of the Tough Cookies audience map."
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return renderImage(
          "/images/county_map_dtom.png",
          "This is an image of the Don't Tread On Me audience map."
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return renderImage(
          "/images/county_map_pp.png",
          "This is an image of the People Power audience map."
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return renderImage(
          "/images/county_map_iyss.png",
          "This is an image of the If You Say So audience map."
        );
    }
  };

  const renderUrl = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return "/images/county_map_tc.png";
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return "/images/county_map_dtom.png";
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return "/images/county_map_pp.png";
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return "/images/county_map_iyss.png";
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Audience By County
      </CardTitle>
      <GraphicCard
        interactiveOnSmallScreens
        title="Audience By County"
        emoji={getAudienceEmoji(activeAudience)}
        imageUrl={renderUrl(activeAudience)}
        imageAlt="Infographic showing the audience breakdown at state county level."
        footnote="Grey indicates insufficient data"
      />
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Gallery</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`audience-maps-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderAudienceImage(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default AudienceMapCard;
